<template>
  <AppContainer
    id="hire-developers"
    class="pt-32 md:pt-40">
    <div
      class="flex w-full flex-col-reverse items-center justify-between gap-10 md:gap-20 xl:flex-row xl:gap-0">
      <div class="flex w-full max-w-xl shrink-0 flex-col items-center gap-10 xl:w-168 xl:max-w-full xl:items-start">
        <h2 class="heading-primary text-center text-3xl font-bold md:text-[40px] md:leading-tight xl:text-left">
          Looking for <em>Certified Developers?</em>
        </h2>
        <p class="text-center text-sm text-eerie-black md:text-base xl:text-left dark:text-white">
          We can help you recruit Certified Developers for your organization or project. The team has helped many customers employ suitable resources from a pool of 100s of qualified Developers.
          <br>
          <br>
          Let us help you get the resources you need.
        </p>
        <a
          href="https://vueschool.typeform.com/to/AugTNesx"
          target="_blank"
          class="btn-primary w-full px-8 py-4 xl:w-fit">
          Contact Us
        </a>
      </div>
      <div class="shrink-0 xl:w-124">
        <div class="rounded-[20px] border border-[#3b5dff] p-6 text-eerie-black shadow-2xl md:p-10 dark:text-white dark:shadow-none">
          <div
            class="rounded-t py-4 text-center text-sm font-medium uppercase"
            :style="{ background: 'linear-gradient(90deg, rgba(66, 85, 255, 0.20) 0%, rgba(0, 163, 255, 0.20) 100%)' }">
            Customer Testimonial <span class="text-azure-radiance">for Hiring</span>
          </div>
          <div class="rounded-b bg-anti-flash p-8 dark:rounded-b dark:bg-[#1f2027]">
            <div class="flex items-center justify-between">
              <InlineSvg
                src="/images/homepage/quote.svg"
                class="h-6 -translate-x-4 -translate-y-2 md:translate-x-0" />
              <span class="text-xl">like a breath of fresh air</span>
              <InlineSvg
                src="/images/homepage/quote.svg"
                class="h-6 translate-y-2 rotate-180" />
            </div>
            <div class="mt-8 flex gap-5">
              <NuxtImg
                loading="lazy"
                src="/images/homepage/testimonial.png"
                alt="Everett Owyoung"
                class="h-12 w-auto" />
              <div>
                <div class="text-lg font-medium">
                  Everett Owyoung
                </div>
                <div class="text-body-gray">
                  Head of Talent for ThousandEyes
                  <br>
                  (a Cisco company)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppContainer>
</template>
